import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutePath } from '../../../layout/Routes'

import { Table, TableBody, TableProvider, TableRow, TableCell, Loader } from '@percent/lemonade'
import { ProgramsTableProps } from './ProgramsTable.types'

export function ProgramsTable({ data, isLoading, totalResults }: Readonly<ProgramsTableProps>) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const columnsPrograms = [{ id: t('table.header.grantPrograms'), isSortable: false }]

  const rowCategoryClicked = (programId: string) => navigate(`${RoutePath.GRANT_PROGRAMS}/${programId}/candidates`)

  if (isLoading) {
    return <Loader />
  }

  return (
    <TableProvider
      columns={columnsPrograms}
      totalResults={totalResults}
      isLoading={isLoading}
      illustration="no-grant-programs"
      emptyTableTitle={t('grants.programsTable.emptyTable.title')}
      emptyTableDescription={t('grants.programsTable.emptyTable.description')}
    >
      <Table>
        <TableBody>
          {data?.map(({ id, name }, _index) => (
            <TableRow
              key={`programs-list-${id}`}
              onClick={() => rowCategoryClicked(id)}
              data-testid={`${name}-program`}
            >
              <TableCell>{name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableProvider>
  )
}
